import { Component, OnInit } from '@angular/core';
import { PropertyService } from './shared/services/property.service';
import { BrandDetailsGQL } from 'src/app/shared/graphql/brand-details.graphql';
import { environment } from 'src/environments/environment';
import { Router, NavigationEnd } from '@angular/router';

declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    private brandDetailsGQL: BrandDetailsGQL,
    private propertyService: PropertyService,
    public router: Router) {
      // this.router.events.subscribe(event => {
      //   if(event instanceof NavigationEnd){
      //     gtag('config', 'UA-79830273-1', {'page_path': event.urlAfterRedirects});
      //   }
      // });
  }

  ngOnInit() { 
    this.getBrandDetails();
  }

  getBrandDetails(): void {
    this.brandDetailsGQL
    .watch({
      externalId: environment.brandExternalId,
    }).valueChanges.subscribe(({data}) => {
      this.propertyService.brandSubject.next(data.brandByExternalId);
    });
  }
}
